module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/react-flexview/index.js
// module id = 457
// module chunks = 0